
(function(){
    angular.module('tmx-app').controller('managePrivilegesCtrl',['$state','ManagePrivilegesService','$mdSidenav',

        function ManagePrivilegesCtrl($state, ManagePrivilegesService, $mdSidenav){

            var managePrivilegesCtrlVM=this;
            managePrivilegesCtrlVM.query = "privileges";
            managePrivilegesCtrlVM.gridData = new kendo.data.ObservableArray([]);
            managePrivilegesCtrlVM.date = new Date().toJSON();
            managePrivilegesCtrlVM.cols = ManagePrivilegesService.filterColumn;
        //managePrivilegesCtrlVM.nav = "SearchSideNav";
            managePrivilegesCtrlVM.schema = ManagePrivilegesService.schema;
            managePrivilegesCtrlVM.cloneColumn = ManagePrivilegesService.gridColumn;
            managePrivilegesCtrlVM.ManagePrivilegesService = ManagePrivilegesService;
            managePrivilegesCtrlVM.promise;

        //*************Functions****************
            managePrivilegesCtrlVM.reload=function(){
                managePrivilegesCtrlVM.container.companyGrid.dataSource.read();
            }

            managePrivilegesCtrlVM.success=function(){
            };

            managePrivilegesCtrlVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            }

            managePrivilegesCtrlVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            managePrivilegesCtrlVM.new = function(){
                $state.go($state.current.name+".add");
            };


            managePrivilegesCtrlVM.clickView = function (item) {
                $state.data.info = true;
                $state.go($state.current.name+".edit",{"Id":item.privilegeId});
            }


//*******************Kendo row template functions****************************


            managePrivilegesCtrlVM.isStatusActive=function(dataitem){
                if(dataitem.EffectiveEndDate<managePrivilegesCtrlVM.date)return true;
                return false;
            }


            managePrivilegesCtrlVM.getPrivilegeNameTest=function(dataitem){
                return dataitem.PrivilegeName;
            }
            managePrivilegesCtrlVM.getPrivilegeName=function(dataitem){
                return dataitem.EntityName;
            }
            managePrivilegesCtrlVM.getTransactionEntityName=function(dataitem){
                return dataitem.TransactionEntityName;
            }

            managePrivilegesCtrlVM.getIcon=function(dataitem,eventname){
                if(eventname=='View'){
                    return dataitem.ViewIcon;
                }
                else if(eventname=="Edit"){
                    return dataitem.EditIcon;
                }
                else if(eventname=="Delete"){
                    return dataitem.DeleteIcon;
                }
                else if(eventname=="Create"){
                    return dataitem.CreateIcon;
                }
                else if(eventname=="Add"){
                    return dataitem.AddIcon;
                }
                else if(eventname=="Assign"){
                    return dataitem.AssignIcon;
                }

                else if(eventname=="Verify"){
                    return dataitem.VerifyIcon;
                }

                else if(eventname=="Approve"){
                    return dataitem.ApproveIcon;
                }


            }


//*******************KENDO*********************//

            managePrivilegesCtrlVM.gridColumns = ManagePrivilegesService.columns;
            managePrivilegesCtrlVM.filters = {};
            managePrivilegesCtrlVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o){
                            managePrivilegesCtrlVM.o = angular.copy(o);
                            managePrivilegesCtrlVM.filters = managePrivilegesCtrlVM.o.data.filter;
                            var promise=ManagePrivilegesService.getByParams(o,true);
                            promise.then(function(response){
                                if(!angular.isDefined(response))return;

                                o.success(response);
                            });
                            return promise;
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "Companies.pdf"
                },
                excel: {
                    allPages: true,
                    fileName: "Companies.xlsx"
                },
                sortable: true,
                scrollable: false,
                rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': ManagePrivilegesCtrl.isStatusActive(dataItem)}\" >" +
            "<td style='height: 50px;'>" +
            "<a class='testClass' ng-disabled='ManagePrivilegesCtrl.isStatusActive(dataItem)' " +
            "ng-click='ManagePrivilegesCtrl.clickEdit(dataItem)'>  {{ManagePrivilegesCtrl.getPrivilegeNameTest(dataItem)}}   " +
            "<md-tooltip md-direction='top'>#=privilegeName#</md-tooltip></a>" +
            "</td>" +
            "<td> #=privilegeDescription# </td>" +

            "</tr>",
                columns: ManagePrivilegesService.columns
            };

            managePrivilegesCtrlVM.container = {};
            $state.data={
                grid: managePrivilegesCtrlVM.container,
                info: false
            };

        }]);

})();
